<div>
    <div class="base-container">
        <div class="mt-2 mb-1">
            <a [routerLink]="['../']" class="font-bolder">
                <span><bd-fa name="chevron-left"></bd-fa> Zurück zur Newsübersicht</span>
            </a>
        </div>
        <div class="iframe-wrapper">
            <iframe *ngIf="htmlLink" class="full-frame" [src]="htmlLink"></iframe>
        </div>
    </div>
</div>
